const getSortable = () => import('sortablejs')

/* @ngInject */
function KanbanController ($scope, $rootScope, $timeout, $state, $location, $translate, $q, SocketService, BoardColumnsService, ConfirmationModalService, BoardsService, SegmentService, ModalService, TasksService, MessageService, LocalStorageService, UdsModalService, WorkflowHeaderService, UiElementViewLogService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))
  const getBoardColumnDialogController = () => import('../../dialogs/board-column/board-column-dialog.controller')
  const getMoveTaskReviewDialogController = () => $q.when(import('../../dialogs/move-task-review/move-task-review-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../dialogs/subtask-details/subtask-details-dialog.controller'))

  $scope.reloadingTasksOnMoveEvt = false
  $scope.filters = {
    isArchived: false,
    showOcculted: false
  }
  $scope.boardColumnDialogData = {
    show: false,
    columnData: null
  }
  $scope.search = undefined
  $scope.sortOptions = ['manual', 'priority', 'deliveryDate']
  $scope.newColumn = {
    name: '',
    boardId: null
  }
  $scope.creatingColumn = false
  $scope.flags = {
    loading: false
  }

  const count = 0
  let sortableColumns = []
  let isDraggingOverColumn = false
  let columnGhost

  const quickFilters = {
    assignees: null,
    authors: null,
    overdue: false
  }

  const api = {
    getBoardColumnDialogController,
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController,
    _shouldHandleTask,
    _handleTaskCreated,
    _handleTaskUpdated,
    _handleTaskRemoved,
    _handleTaskMoved,
    _handleTaskDuplicated,
    _handleSocketReconnect,
    _handleChangeColumnTask,
    _changeTaskStatus,
    _countTaskInColumn,
    _resetTaskColumn,
    _orderColumn,
    _doDataFlow,
    _successGetColumns,
    _succesGetTasksByColumn,
    _loadMoreTasks,
    _openRequestDetailDialog,
    _initializeSortable,
    _successMoveColumn,
    _disableSortableColumn,
    _onChange,
    _onSort,
    _onAdd,
    _onUpdate,
    _onMove,
    _onStart,
    _onEnd,
    _setInfiniteScroll,
    _initObserverLoadMore,
    _showTask,
    _setCountAndLoadMoreTask,
    _connectSocket,
    _connectSocketWorkflow,
    _handleChangeFilters,
    _getHeaderInfo,
    _onFilters,
    _onQuickFilters,
    _handleQuickFilter,
    _showOcculted,
    _openSubtaskDetailDialog,
    _validateAndOpenRequestDialog,
    _setTaskUrlParams,
    _handleMoveTaskWithSubtask,
    _setLocalStorageFilter
  }
  this.getApi = () => api

  activate()

  function activate () {
    const url = $location.search()
    $scope.boardId = url.board

    $rootScope.getUser().then(user => {
      if (!$rootScope.isUserSysAdminAdminDesigner(user)) {
        $state.go('workflow.requests')
      }

      if (!url.board) {
        $state.go('workflow.home')
        return
      }

      if (url.term) {
        $scope.search = url.term
      }

      if (url.subtask) {
        api._openSubtaskDetailDialog(url.subtask)
      } else if (url.request) {
        api._validateAndOpenRequestDialog(url.request)
      } else if (url.task) {
        api._showTask({
          data: {
            taskId: url.task
          }
        })
      }
      api._doDataFlow()
      TasksService.getRequestsCount().then(count => {
        $scope.requestsCount = count
      })
    })
  }

  // Disconnect socket when user leave the page
  const deregisterStateChangeStart = $scope.$on('$stateChangeStart', () => {
    SocketService.disconnectSocket()
  })

  const deregisterSavedColumn = $scope.$on('workflow.saved-column', () => {
    return BoardColumnsService.getBoardColumns($scope.boardId).then(columns => api._successGetColumns(columns, count))
  })

  const deregisterOnBoardChange = $scope.$on('workflow-board-updated', (evt, data) => {
    $scope.board = data.board
  })

  const deregisterResetTaskColumn = $rootScope.$on('reset-task-column', api._resetTaskColumn)

  $scope.onSearchTasks = (searchTerm) => {
    $scope.search = searchTerm

    const url = $location.search()

    if (searchTerm) {
      $location.search({ ...url, term: searchTerm })
    } else {
      $location.search({ ...url, term: null })
    }

    BoardColumnsService.getBoardColumns($scope.boardId).then(columns => api._successGetColumns(columns, count))

    SegmentService.track('workflow-search', {
      place: $state.current.name,
      board: $scope.boardId,
      search_text: searchTerm
    })
  }

  const deregisterWorkflowReloadColumn = $rootScope.$on('workflow.reloadColumn', (event, columnChanged) => {
    const column = $scope.columns.find(column => column.id === columnChanged)

    if (!column) {
      return
    }

    let ordernation = null

    if (column.selectedSortOption && column.selectedSortOption !== 'manual') {
      ordernation = {
        sort: column.selectedSortOption,
        order: column.selectedSortOption === 'deliveryDate' ? 'ASC' : 'DESC'
      }
    }

    BoardColumnsService.getTasksForColumn(columnChanged, 0, 0, $scope.filters, $scope.search, ordernation).then(tasks =>
      api._succesGetTasksByColumn(tasks, column, true)
    )
  })

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    WorkflowHeaderService.openCreateTaskDialog(data?.createMore)
  })

  const deregisterSocketConnected = $rootScope.$on('socket-connected-successfully-Workflow', () => {
    SocketService.registerEvent('taskCreated', api._handleTaskCreated)
    SocketService.registerEvent('taskUpdated', api._handleTaskUpdated)
    SocketService.registerEvent('taskRemoved', api._handleTaskRemoved)
    SocketService.registerEvent('taskMoved', api._handleTaskMoved)
    SocketService.registerEvent('taskDuplicated', api._handleTaskDuplicated)
    SocketService.registerEvent('reconnect', api._handleSocketReconnect)
  })

  const deregisterWorkflowReload = $rootScope.$on('workflow.reload', () => {
    api._doDataFlow()
  })

  $scope.$on('$destroy', () => {
    deregisterStateChangeStart()
    deregisterResetTaskColumn()
    deregisterWorkflowReloadColumn()
    deregisterSocketConnected()
    deregisterOnBoardChange()
    deregisterSavedColumn()
    deregisterTaskCardCreated()
    deregisterWorkflowReload()
    deregisterOpenRequestDetailsDialog()
    deregisterReopenCreateTaskDialog()
  })

  $scope.loadMoreTasks = api._loadMoreTasks

  $scope.changeColumnSortOption = function (column, option) {
    api._orderColumn(column, option)
  }

  $scope.openNewColumnDialog = function () {
    $scope.openBoardColumnDialog()
  }

  $scope.openMoveTaskReview = function () {
    getMoveTaskReviewDialogController().then(({ MoveTaskReviewDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: MoveTaskReviewDialogController,
        modalName: 'moveTaskReviewDialog'
      })
      modal.open()
    })
  }

  $scope.showFinishedTasks = function () {
    const url = $location.search()

    $location.path('/workflow/list').search({ ...url, taskStatus: 'DONE' })

    SegmentService.track('workflow-kanban-autohide-help-click', { board_name: $scope.board.name })
  }

  $scope.openColumnSettingsDialog = function (column) {
    $scope.openBoardColumnDialog(column)
  }

  $scope.openTaskDetails = function (task) {
    const { id } = task

    if (task.originType === 'SUBTASK') {
      api._openSubtaskDetailDialog(id)
      return
    }

    api._openRequestDetailDialog(id)
  }

  $scope.moveColumn = function (columnId, direction) {
    BoardColumnsService.moveColumn(columnId, direction).then(() => api._successMoveColumn(columnId, direction))
  }

  $scope.archiveAllTasks = function (column) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureArchiveAllTasks'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      closeOnConfirm: true,
      press: function () {
        BoardColumnsService.archiveAllTasks(column.id).then(() => {
          column.tasks = []
          column.taskCount = 0
        })
      }
    })
  }

  /**
   * Called a board is loaded. Create a socket connection to that board
   *
   * @param {object} task Created task object
   */
  function _connectSocket (boardId) {
    const retryTime = 5000
    let attempts = 0

    api._connectSocketWorkflow(boardId)

    const retryInterval = setInterval(() => {
      if (!SocketService.isConnected() && attempts < 5) {
        attempts++
        api._connectSocketWorkflow(boardId)
      } else {
        clearInterval(retryInterval)
      }
    }, retryTime)
  }

  function _connectSocketWorkflow (boardId) {
    SocketService.disconnectSocket()
    SocketService.connectSocket('Workflow', { query: { boardId } })
  }

  function _shouldHandleTask ({ originType }) {
    const { taskTypes } = $scope.filters

    // Unselected task types always filter TASK's and REQUEST's. SUBTASK's will be ignored.
    if (!taskTypes) {
      return originType === 'TASK' || originType === 'REQUEST'
    }

    if (taskTypes.includes(',')) {
      return taskTypes.split(',').includes(originType)
    }

    return taskTypes === originType
  }

  /**
   * Called when a new task is created on board or when an request become a task
   * Recieve the created task as object
   *
   * @param {object} task Created task object
   */
  function _handleTaskCreated (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    let columnIndex = 0

    if (task.to) {
      columnIndex = $scope.columns.findIndex(column => task.to === column.id)
    }

    const columnTaskCount = $scope.columns[columnIndex].taskCount

    api._succesGetTasksByColumn(
      {
        rows: [task],
        count: api._countTaskInColumn(columnTaskCount)
      },
      $scope.columns[columnIndex]
    )
  }

  /**
   * Called when a some task info is updated
   * Recieve task object with updated data
   *
   * @param {object} task Updated task object
   */
  function _handleTaskUpdated (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    if ($scope.reloadingTasksOnMoveEvt) {
      setTimeout(() => {
        api._handleTaskUpdated(task)
      }, 1000)
      return
    }

    const columnIndex = $scope.columns.findIndex(column =>
      task.oldColumnId ? task.oldColumnId === column.id : task.columnId === column.id
    )
    const oldTaskIndex = $scope.columns[columnIndex].tasks.findIndex(columnTask => task.id === columnTask.id)
    const oldTask = $scope.columns[columnIndex].tasks[oldTaskIndex]

    if (!oldTask || oldTask.status !== task.status) {
      return
    }

    $timeout(() => {
      if (oldTask.priority !== task.priority) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].priority = task.priority
        if ($scope.columns[columnIndex].selectedSortOption === 'priority') {
          api._orderColumn($scope.columns[columnIndex], 'priority')
        }
      }

      if (oldTask.title !== task.title) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].title = task.title
      }

      if (oldTask.assignees?.length !== task.assignees?.length) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].assignees = task.assignees
      }

      if (oldTask.deliveryDate !== task.deliveryDate) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].deliveryDate = task.deliveryDate
        if ($scope.columns[columnIndex].selectedSortOption === 'deliveryDate') {
          api._orderColumn($scope.columns[columnIndex], 'deliveryDate')
        }
      }

      if (oldTask.comments && task.comments && oldTask.comments.count !== task.comments.count) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].comments.count = task.comments.count
        $scope.columns[columnIndex].tasks[oldTaskIndex].unread_comments = true
      }

      if (oldTask.status !== task.status) {
        $scope.columns[columnIndex].tasks[oldTaskIndex].status = task.status
      }
      $scope.columns[columnIndex].tasks[oldTaskIndex].updatedAt = new Date().toISOString()
    }, 150)
  }

  /**
   * Called when a task is removed from kanban (archived)
   * Recieve removed task info
   *
   * @param {object} task Updated task object
   */
  function _handleTaskRemoved (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    $timeout(() => {
      const columnIndex = $scope.columns.findIndex(column => task.columnId === column.id)
      const taskIndex = $scope.columns[columnIndex].tasks.findIndex(columnTask => task.taskId === columnTask.id)

      if (taskIndex >= 0) {
        $scope.columns[columnIndex].tasks.splice(taskIndex, 1)
      }
    }, 100)
  }

  /**
   * Called when a task position is changed between columns
   * Recieve moved task info task info
   *
   * @param {object} task Updated task object
   * @param {object} from Original task column id
   * @param {object} to New task column id
   */
  function _handleTaskMoved (movedInfo) {
    if (!api._shouldHandleTask(movedInfo.task)) {
      return
    }

    const oldColumn = $scope.columns.findIndex(column => movedInfo.from === column.id)
    const movedTaskIndex = $scope.columns[oldColumn].tasks.findIndex(task => movedInfo.taskId === task.id)
    const movedTask = $scope.columns[oldColumn].tasks[movedTaskIndex]

    $timeout(() => {
      if (movedInfo.from === movedInfo.to) {
        $scope.columns[oldColumn].tasks.splice(
          movedInfo.position,
          0,
          $scope.columns[oldColumn].tasks.splice(movedTaskIndex, 1)[0]
        )
        return
      }

      if (movedTask) {
        movedTask.assignees = movedInfo.assignees || []
      }

      const newColumn = $scope.columns.findIndex(column => movedInfo.to === column.id)

      $scope.columns[oldColumn].taskCount--
      $scope.columns[newColumn].taskCount++

      if (movedTaskIndex !== -1) {
        $scope.columns[oldColumn].tasks.splice(movedTaskIndex, 1)
      }

      $scope.columns[newColumn].skip = 20

      $scope.reloadingTasksOnMoveEvt = true
      if ($scope.columns[newColumn].selectedSortOption !== 'manual') {
        BoardColumnsService.getTasksForColumn(
          $scope.columns[newColumn].id,
          $scope.columns[newColumn].top,
          0,
          $scope.filters,
          $scope.search,
          { sort: $scope.columns[newColumn].selectedSortOption, order: $scope.columns[newColumn].selectedSortOption === 'deliveryDate' ? 'ASC' : 'DESC' }
        ).then(tasks => api._succesGetTasksByColumn(tasks, $scope.columns[newColumn], true))
      } else {
        BoardColumnsService.getTasksForColumn(
          $scope.columns[newColumn].id,
          $scope.columns[newColumn].top,
          0,
          $scope.filters,
          $scope.search
        ).then(tasks => api._succesGetTasksByColumn(tasks, $scope.columns[newColumn], true))
      }
    })
  }

  /**
   * Called when a new task is duplicated on board
   * Recieve the duplicated task as object
   *
   * @param {object} task duplicated task object
   */
  function _handleTaskDuplicated (task) {
    if (!api._shouldHandleTask(task)) {
      return
    }

    let columnIndex = 0

    if (task.to) {
      columnIndex = $scope.columns.findIndex(column => task.to === column.id)
    }

    $timeout(() => {
      $scope.flags.loading = false

      if (!$scope.columns[columnIndex].tasks.length) {
        $scope.columns[columnIndex].tasks = [task]
      } else {
        const nextPositionOriginTask = task.position - 1
        $scope.columns[columnIndex].tasks.splice(nextPositionOriginTask, 0, ...[task])
      }

      const tasksColumnLength = $scope.columns[columnIndex].length
      $scope.columns[columnIndex].taskCount = $scope.columns[columnIndex].tasks.length
      $scope.columns[columnIndex].loadMore = $scope.columns[columnIndex].tasks.length > tasksColumnLength
      $scope.reloadingTasksOnMoveEvt = false
    }, 200)
  }

  function _handleChangeFilters () {
    const filters = api._showOcculted()

    if ($scope.columns) {
      $scope.columns.forEach(column => {
        column.skip = 20
        $scope.flags.loading = true
        if (column.selectedSortOption !== 'manual') {
          BoardColumnsService.getTasksForColumn(
            column.id,
            column.top,
            0,
            filters,
            $scope.search,
            { sort: column.selectedSortOption, order: column.selectedSortOption === 'deliveryDate' ? 'ASC' : 'DESC' }
          ).then(tasks => api._succesGetTasksByColumn(tasks, column, true))
        } else {
          BoardColumnsService.getTasksForColumn(column.id, column.top, 0, filters, $scope.search).then(tasks =>
            api._succesGetTasksByColumn(tasks, column, true)
          )
        }
      })
    }
  }

  function _handleChangeColumnTask (to, taskId, from, position) {
    const newColumn = $scope.columns.find(column => column.id === to)
    const oldColumn = $scope.columns.find(column => column.id === from)
    const task = oldColumn?.tasks?.find(task => task.id === taskId)
    const ignoreMoveAutomatically = true

    api._changeTaskStatus(task, oldColumn, newColumn, position, ignoreMoveAutomatically).then(() => {
      const isReviewColumn = newColumn.defaultStatus === 'REVIEW'

      SegmentService.track('moved-task', { task_id: taskId, type: task.originType })

      if (newColumn?.defaultStatus === 'DONE' && task?.status !== 'DONE') {
        SegmentService.track('finished-task', { type: task.originType, task_id: taskId, briefing_id: task.briefingId })
      }

      if (task.status !== 'REVIEW' && isReviewColumn) {
        SegmentService.track('sent-to-review-task', { task_id: taskId })
      }

      if (task.status === 'DONE' && newColumn.defaultStatus !== 'DONE') {
        SegmentService.track('reopened-task', { task_id: taskId })
      }

      if (newColumn.selectedSortOption !== 'manual') {
        api._orderColumn(newColumn, newColumn.selectedSortOption)
      }

      $rootScope.getUser().then(oUser => {
        const showMoveTaskReviewDialog = JSON.parse(LocalStorageService.get(`${oUser.id}-showMoveTaskReviewDialog`))
        if (isReviewColumn && task.originType === 'REQUEST' && !showMoveTaskReviewDialog) {
          $scope.openMoveTaskReview()
        }
      })
    })
  }

  function _changeTaskStatus (task, oldColumn, newColumn, position, ignoreMoveAutomatically) {
    if (task.originType === 'SUBTASK') {
      return TasksService.changeSubtaskStatus(task, oldColumn, newColumn, position, ignoreMoveAutomatically)
    }

    return TasksService.changeTaskStatus(task, oldColumn, newColumn, position, ignoreMoveAutomatically)
  }

  function _countTaskInColumn (currentCountTask) {
    return currentCountTask + 1
  }

  function _resetTaskColumn (event, from, to) {
    const fromColumn = $scope.columns.find(column => column.id === from)
    const toColumn = $scope.columns.find(column => column.id === to)
    BoardColumnsService.getTasksForColumn(from, 0, 0, $scope.filters, $scope.search).then(tasks =>
      api._succesGetTasksByColumn(tasks, fromColumn, true)
    )
    BoardColumnsService.getTasksForColumn(to, 0, 0, $scope.filters, $scope.search).then(tasks =>
      api._succesGetTasksByColumn(tasks, toColumn, true)
    )
  }

  function _orderColumn (column, option) {
    const params = $scope.filters
    column.selectedSortOption = option
    column.skip = 20

    let sortableStatus = true

    const localStorageParams = {
      boardId: column.boardId,
      columnId: column.id,
      option: option
    }
    api._setLocalStorageFilter(localStorageParams)

    if (option !== 'manual') {
      sortableStatus = false
      const order = option === 'deliveryDate' ? 'ASC' : 'DESC'

      BoardColumnsService.getTasksForColumn(column.id, column.top, 0, params, $scope.search, { sort: option, order }).then(tasks =>
        api._succesGetTasksByColumn(tasks, column, true)
      )
    } else {
      BoardColumnsService.getTasksForColumn(column.id, column.top, 0, params, $scope.search).then(tasks =>
        api._succesGetTasksByColumn(tasks, column, true)
      )
    }

    api._disableSortableColumn(column.id, sortableStatus)
  }

  function _setLocalStorageFilter (params) {
    const { boardId, columnId, option } = params
    LocalStorageService.set(`board-${boardId}-column-${columnId}-filter`, option)
  }

  function _doDataFlow () {
    const url = $location.search()
    const showFinishedTasks = Array.isArray(url.taskStatus) ? url.taskStatus.some(status => status === 'DONE') : url.taskStatus === 'DONE'

    if (showFinishedTasks) {
      $scope.filters.taskStatus = url.taskStatus
    }

    const promises = [
      BoardsService.getBoardById($scope.boardId).then(board => {
        $scope.board = board
        api._getHeaderInfo(board, showFinishedTasks)
      }),
      BoardColumnsService.getBoardColumns($scope.boardId).then(columns => api._successGetColumns(columns, count))
    ]
    $scope.flags.loading = true
    api._connectSocket($scope.boardId)

    return Promise.all(promises).then(() => {
      api._setInfiniteScroll()
    })
  }

  function _successGetColumns (columns, count) {
    const filters = api._showOcculted()

    columns.forEach(column => {
      column.selectedSortOption = LocalStorageService.get(`board-${column.boardId}-column-${column.id}-filter`) ?? 'manual'
      column.top = 20
      column.skip = 20

      const ordenation = {
        sort: column.selectedSortOption,
        order: column.selectedSortOption === 'deliveryDate' ? 'ASC' : 'DESC'
      }

      BoardColumnsService.getTasksForColumn(
        column.id,
        column.top,
        0,
        filters,
        $scope.search,
        column.selectedSortOption !== 'manual' ? ordenation : null
      ).then(tasks => {
        column.tasks = tasks.rows

        api._setCountAndLoadMoreTask(tasks, column)

        count++

        if (count === columns.length && column.selectedSortOption === 'manual') {
          $timeout(
            () => {
              api._initializeSortable()
            },
            500,
            false
          )
        }
      })
    })
    $scope.columns = columns
    $scope.flags.loading = false
  }

  function _succesGetTasksByColumn (tasks, column, reset) {
    if (reset) {
      column.tasks = []
    }

    $timeout(() => {
      $scope.flags.loading = false

      if (!column.tasks.length || reset) {
        column.tasks = tasks.rows
      } else {
        column.tasks.push(...tasks.rows)
      }

      api._setCountAndLoadMoreTask(tasks, column)
      $scope.reloadingTasksOnMoveEvt = false
    }, 200)
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: (data) => {
          if (!data) {
            api._setTaskUrlParams()
            return
          }

          if (data?.wasUpdated && data?.reloadColumn) {
            const column = $scope.columns.find(column => column.id === data.reloadColumn)
            BoardColumnsService.getTasksForColumn(data.reloadColumn, 0, 0, $scope.filters, $scope.search).then(tasks =>
              api._succesGetTasksByColumn(tasks, column, true)
            )
          } else if (data?.reloadTaskTags) {
            const column = $scope.columns.find(column => column.id === data.reloadTaskTags.columnId)
            if (!column) return
            const task = column.tasks.find(task => task.id === data.reloadTaskTags.taskId)
            if (!task) return
            task.tags = data.reloadTaskTags.tags
          }

          $timeout(() => {
            const columnIndex = $scope.columns.findIndex(column => {
              return column.tasks.find(columnTask => id === columnTask.id)
            })
            if (columnIndex !== -1 && $scope.columns[columnIndex]) {
              const taskIndex = $scope.columns[columnIndex].tasks.findIndex(columnTask => id === columnTask.id)
              const task = $scope.columns[columnIndex].tasks[taskIndex]
              task.unread_comments = false
              task.attachments.hasUnreadAttachments = false
              if (data.attachmentsCount !== undefined) {
                task.attachments.count = data.attachmentsCount
              }
              if (task.unread_comments || data.wasUpdated) {
                task.updatedAt = new Date().toISOString()
              }
            }
          }, 500)
        }
      })
      modal.open()
    })
  }

  $scope.openBoardColumnDialog = function (column) {
    getBoardColumnDialogController().then(({ BoardColumnDialogController }) => {
      const boardColumnDialog = UdsModalService.createModal({
        controller: BoardColumnDialogController,
        modalName: 'boardColumnDialog',
        data: ($scope.boardColumnDialogData = {
          boardId: $scope.boardId,
          columnData: column
        })
      })

      boardColumnDialog.open()
    })
  }

  function _successMoveColumn (columnId, direction) {
    const columnIndex = $scope.columns.findIndex(column => column.id === columnId)
    const movedColumn = $scope.columns[columnIndex]

    if (direction === 'LEFT') {
      $scope.columns[columnIndex] = $scope.columns[columnIndex - 1]
      $scope.columns[columnIndex - 1] = movedColumn

      $scope.columns[columnIndex].order++
      $scope.columns[columnIndex - 1].order--
    } else {
      $scope.columns[columnIndex] = $scope.columns[columnIndex + 1]
      $scope.columns[columnIndex + 1] = movedColumn

      $scope.columns[columnIndex].order--
      $scope.columns[columnIndex + 1].order++
    }
  }

  function _loadMoreTasks (column) {
    column.loading = true

    if (column.selectedSortOption !== 'manual') {
      BoardColumnsService.getTasksForColumn(
        column.id,
        column.top,
        column.skip,
        $scope.filters,
        $scope.search,
        { sort: column.selectedSortOption, order: column.selectedSortOption === 'deliveryDate' ? 'ASC' : 'DESC' }
      ).then(tasks => {
        api._succesGetTasksByColumn(tasks, column)
        column.loading = false
      })
    } else {
      BoardColumnsService.getTasksForColumn(column.id, column.top, column.skip, $scope.filters, $scope.search).then(
        tasks => {
          api._succesGetTasksByColumn(tasks, column)
          column.loading = false
        }
      )
    }
    column.skip = column.skip + 20
  }

  function _initializeSortable () {
    getSortable().then(({ Sortable }) => {
      let sortableElements = document.getElementsByClassName('column-content')
      sortableElements = Array.from(sortableElements)

      sortableColumns = []

      sortableElements.forEach(element => {
        sortableColumns.push(Sortable.create(element, {
          group: 'sorting',
          sort: true,
          animation: 150,
          ghostClass: 'task-ghost',
          filter: '.static',
          delayOnTouchOnly: true,
          delay: 200,
          draggable: '.task-outer-class',
          onChange: api._onChange,
          onSort: api._onSort,
          onAdd: api._onAdd,
          onUpdate: api._onUpdate,
          onMove: api._onMove,
          onStart: api._onStart,
          onEnd: api._onEnd
        }))
      })
    })
  }

  function _disableSortableColumn (columnId, status) {
    const element = sortableColumns.find(column => parseInt(column.el.id) === columnId)
    element.option('sort', status)

    if (!status) {
      element.options.ghostClass = 'disabled-task-ghost'
    } else {
      element.options.ghostClass = 'task-ghost'
    }
  }

  function _onChange (event) {
    if (isDraggingOverColumn) {
      columnGhost.classList.remove('column-ghost')
      isDraggingOverColumn = false
    }

    if (event.from === event.to) {
      return
    }
    const element = sortableColumns.find(column => column.el.id === event.to.id)

    if (element.options.sort) {
      return
    }

    isDraggingOverColumn = true
    columnGhost = event.to.parentElement
    columnGhost.classList.add('column-ghost')
  }

  function _onSort (event) {
    if (isDraggingOverColumn) {
      columnGhost.classList.remove('column-ghost')
      isDraggingOverColumn = false
    }
  }

  function _onAdd (event) {
    const taskId = parseInt(event.item.id)
    const from = parseInt(event.from.id)
    const to = parseInt(event.to.id)
    const position = event.newIndex

    const newColumn = $scope.columns.find(column => column.id === to)
    const column = $scope.columns.find(column => column.id === from)
    const { subtasks } = column?.tasks?.find(task => task.id === taskId)

    if (subtasks?.count > 0 && newColumn.defaultStatus === 'DONE') {
      api._handleMoveTaskWithSubtask(event, to, taskId, from, position, subtasks.count)
      return
    }

    api._handleChangeColumnTask(to, taskId, from, position)
  }

  function _onUpdate (event) {
    const taskId = parseInt(event.item.id)
    const from = parseInt(event.from.id)
    const position = event.newIndex

    const column = $scope.columns.find(column => column.id === from)
    const task = column?.tasks?.find(task => task.id === taskId)

    TasksService.updateTaskPosition({ id: taskId, originType: task.originType }, from, from, position)
  }

  function _onMove (event) {
    const taskId = parseInt(event.dragged.id)
    const to = parseInt(event.to.id)
    const from = parseInt(event.from.id)
    const column = $scope.columns.find(column => column.id === from)
    const newColumn = $scope.columns.find(column => column.id === to)
    const task = column?.tasks?.find(task => task.id === taskId)

    if (task.originType === 'SUBTASK' && !['INBOX', 'PROGRESS', 'DONE'].includes(newColumn.defaultStatus)) {
      return false
    }

    return !Array.from(event.related.classList).includes('static')
  }

  function _onStart () {
    $('.column-content.empty').addClass('empty-hidden')
    $('.see-occulted-tasks').addClass('hidden-text')
  }

  function _onEnd () {
    $timeout(() => {
      $('.column-content.empty').removeClass('empty-hidden')
      $('.see-occulted-tasks').removeClass('hidden-text')
    }, 200)
  }

  function _handleMoveTaskWithSubtask (event, to, taskId, from, position, subtaskCount) {
    ConfirmationModalService.createModal({
      title: $translate.instant('taskFinishWarning.title'),
      description: $translate.instant('taskFinishWarning.description', { count: subtaskCount }),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('confirm'),
      onConfirm: () => {
        api._handleChangeColumnTask(to, taskId, from, position)
      },
      onCancel: () => {
        if (event.oldIndex >= event.from.children.length) {
          event.from.appendChild(event.item)
        } else {
          event.from.insertBefore(event.item, event.from.children[event.oldIndex])
        }
      }
    })
  }

  function _setInfiniteScroll () {
    const loadMoreButtons = document.querySelectorAll('.load-more-tasks-btn')

    $timeout(
      () => {
        $('.columns-board .column').each(function (index) {
          const column = $scope.columns[index]

          api._initObserverLoadMore(loadMoreButtons, column, index)
        })
      },
      250,
      false
    )
  }

  function _initObserverLoadMore (loadMoreButtons, column, index) {
    if (loadMoreButtons[index] && !$scope.flags.loading) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: [0.0, 0.4]
      }

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && column.loadMore) {
          api._loadMoreTasks(column)
        }
      }, options)

      observer.observe(loadMoreButtons[index])
    }
  }

  function _showTask (params) {
    ModalService.showModal({
      templateId: 'taskDetailsDialog.html',
      templateUrl: '/workflow/dialogs/task-details/task-details-dialog.html?$$REVISION$$',
      destroyable: true,
      observeChanges: true,
      data: params.data,
      controller: 'TaskDetailsDialogController'
    }).then(params.callback)
  }

  function _setCountAndLoadMoreTask (tasks, column) {
    const tasksLength = parseInt(tasks.count, 10)
    const tasksColumnLength = column.tasks.length

    column.taskCount = tasksLength
    column.loadMore = tasksLength > tasksColumnLength
  }

  // Reload the board after socket reconnect to assure syncrony
  function _handleSocketReconnect () {
    return api._doDataFlow()
  }

  const deregisterTaskCardCreated = $scope.$on('taskCardCreated', () => {
    api._handleSocketReconnect()
  })

  const deregisterOpenRequestDetailsDialog = $scope.$on('kanban.openRequestDetailsDialog', ($event, { taskId }) => {
    api._openRequestDetailDialog(taskId)
  })

  function _getHeaderInfo (board, showFinishedTasks = false) {
    $scope.headerNavigation = WorkflowHeaderService.getHeaderNavigation(board)
    WorkflowHeaderService.getHeaderToolbar(
      $translate,
      board,
      {
        onSearch: $scope.onSearchTasks,
        onFilter: api._onFilters,
        onQuickFilters: api._onQuickFilters,
        value: $scope.search
      },
      $rootScope.oUser.locale,
      $rootScope.isDesktop,
      showFinishedTasks
    ).then(headerToolbar => { $scope.headerToolbar = headerToolbar })
  }

  function _onQuickFilters (filter) {
    if (filter === 'assignedToMe') {
      api._handleQuickFilter('assignees')
      quickFilters.assignees = quickFilters.assignees ? null : $rootScope.oUser.id
      quickFilters.authors = null
    }

    if (filter === 'createdByMe') {
      api._handleQuickFilter('authors')
      quickFilters.authors = quickFilters.authors ? null : $rootScope.oUser.id
      quickFilters.assignees = null
    }

    if (filter === 'overdue') {
      api._handleQuickFilter('overdue')
      quickFilters.overdue = !quickFilters.overdue
    }

    api._handleChangeFilters()
  }

  function _handleQuickFilter (filter) {
    $scope.filters.overdue = !!$scope.filters.overdue

    if (!$scope.filters.assignees) {
      $scope.filters.assignees = []
    }

    if (!$scope.filters.authors) {
      $scope.filters.authors = []
    }

    const indexAssigness = $scope.filters.assignees.findIndex(item => item === $rootScope.oUser.id)
    const indexAuthors = $scope.filters.authors.findIndex(item => item === $rootScope.oUser.id)

    if (filter === 'assignees' && indexAssigness === -1) {
      $scope.filters.assignees.push($rootScope.oUser.id)
      $scope.filters.taskTypes = 'TASK,REQUEST,SUBTASK'

      if (indexAuthors !== -1) {
        $('header .toolbar uds-button.created-by-me').click()
      }
    } else if (filter === 'assignees' && indexAssigness !== -1) {
      $scope.filters[filter].splice(indexAssigness, 1)
      delete $scope.filters.taskTypes
    } else if (filter === 'authors' && indexAuthors === -1) {
      $scope.filters.authors.push($rootScope.oUser.id)

      if (indexAssigness !== -1) {
        $('header .toolbar uds-button.assigned-to-me').click()
      }
    } else if (filter === 'authors' && indexAuthors !== -1) {
      $scope.filters[filter].splice(indexAuthors, 1)
    } else if (filter === 'overdue') {
      $scope.filters[filter] = !$scope.filters[filter]
    }
  }

  $scope.columnTagActions = {
    changeSort: $scope.changeColumnSortOption,
    moveColumn: $scope.moveColumn,
    openSettings: $scope.openColumnSettingsDialog,
    archiveAllTasks: $scope.archiveAllTasks
  }

  function _onFilters (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    $scope.filters = {
      ...$scope.filters,
      ...filters
    }

    WorkflowHeaderService.mergeQuickFilters($scope.filters, quickFilters)

    const url = $location.search()

    if (!$scope.filters.taskStatus?.length && url.taskStatus) {
      $location.search({ ...url, taskStatus: null })
    }

    api._handleChangeFilters()
  }

  function _showOcculted () {
    const filters = {
      ...$scope.filters
    }

    filters.showOcculted = $scope.search ? undefined : false

    return filters
  }

  function _openSubtaskDetailDialog (id) {
    TasksService.getTaskById(id).then((subtask) => {
      api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: SubtaskDetailsDialogController,
          modalName: 'subtaskDetailsDialog',
          data: {
            subtask: subtask
          },
          onClose: (data) => {
            if (!data) {
              api._setTaskUrlParams()
            }
          }
        })

        modal.open()
      })
    })
  }

  function _validateAndOpenRequestDialog (id) {
    TasksService.getTaskById(id).then((task) => {
      if (task.originType === 'SUBTASK') {
        api._openSubtaskDetailDialog(id)
      } else {
        api._openRequestDetailDialog(id)
      }
    }).catch(() => {
      api._openRequestDetailDialog(id)
    })
  }

  function _setTaskUrlParams (taskId, subtaskId) {
    const url = $location.search()

    const request = {
      request: taskId || null,
      subtask: subtaskId || null
    }
    const searchOptions = Object.assign({}, url, request)

    $location.search(searchOptions)
  }
}

export { KanbanController }
